export default "__VITE_ASSET__nOCrAMnm__"